import React, { useState, useRef, useEffect } from 'react';
import { 
  MdMoreVert, 
  MdEdit, 
  MdDelete, 
  MdVisibility, 
  MdAssignment, 
  MdCheckCircle,
  MdBlock,
  MdCheck,
  MdReply,
  MdToggleOff,
  MdToggleOn,
  MdMarkEmailRead,      
  MdMarkEmailUnread,
  MdAddCircle
} from 'react-icons/md';
import '../../../../assets/css/components/admin/dropdown/action/ActionDropdown.css';

const iconMap = {
  MdEdit, MdDelete, MdVisibility, MdAssignment, MdCheckCircle,
  MdBlock, MdCheck, MdReply, MdToggleOff, MdToggleOn,
  MdMarkEmailRead, MdMarkEmailUnread, MdAddCircle,
};

function ActionDropdown({ actions = [] }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => {
    if (!showDropdown && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const dropdownWidth = 160;
      const dropdownHeight = actions.length * 45;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;

      let top = rect.bottom + 8;
      let left = rect.right - dropdownWidth;

      if (top + dropdownHeight > windowHeight) {
        top = rect.top - dropdownHeight - 8;
      }
      if (left < 0) {
        left = rect.left;
      }
      if (left + dropdownWidth > windowWidth) {
        left = windowWidth - dropdownWidth - 8;
      }

      setDropdownStyle({
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        zIndex: 9999,
      });
    }
    setShowDropdown(!showDropdown);
  };

  const handleAction = (action) => {
    setShowDropdown(false);
    if (action.onClick) {
      action.onClick();
    }
  };

  // ── koi action hi nahi to kuch render na karein ──
  if (actions.length === 0) return null;

  // ── sirf 1 action ho to seedha icon button dikhayein, dropdown ki zarurat nahi ──
  if (actions.length === 1) {
    const singleAction = actions[0];
    const SingleIcon = iconMap[singleAction.icon] || MdVisibility;
    return (
      <button
        className={`sadmin-action-trigger sadmin-action-single ${singleAction.className || ''}`}
        onClick={() => handleAction(singleAction)}
        title={singleAction.label}
      >
        <SingleIcon />
      </button>
    );
  }

  // ── 2 ya zyada actions ho to purana 3-dot dropdown ──
  return (
    <div className="sadmin-action-dropdown" ref={dropdownRef}>
      <button
        ref={triggerRef}
        className="sadmin-action-trigger"
        onClick={handleToggle}
        title="Actions"
      >
        <MdMoreVert />
      </button>

      {showDropdown && (
        <div className="sadmin-action-menu" style={dropdownStyle}>
          {actions.map((action, index) => {
            const IconComponent = iconMap[action.icon];
            return (
              <button
                key={index}
                className={`sadmin-action-menu-item ${action.className || ''}`}
                onClick={() => handleAction(action)}
              >
                {IconComponent && <IconComponent />}
                <span>{action.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ActionDropdown;
